import script from "./School.vue?vue&type=script&lang=ts&setup=true"
export * from "./School.vue?vue&type=script&lang=ts&setup=true"

import "./School.vue?vue&type=style&index=0&id=ad83d51e&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ad83d51e"]])

export default __exports__